import { combineReducers } from 'redux';
import importMediaReducer, { IMediaImportState } from './imported/reducer';
import uploadsReducer, { MediaUploadsState } from './uploads/reducer';

interface IMediaState {
  imported?: IMediaImportState;
  uploads: MediaUploadsState;
}

export type { IMediaState };
export default combineReducers({
  imported: importMediaReducer,
  uploads: uploadsReducer,
});
